let Form = {
    onload: document.addEventListener('DOMContentLoaded', function() {
        Form.init();
    }),

    init: function() {
        this.bind();
    },

    bind: function() {
        $(document).on('click', 'button.form-submit', function (event) {
            event.preventDefault();

            Form.$form = $(this).closest('form[data-type]');

            const type = parseInt(Form.$form.data('type'));

            Form.ajax.sendForm($(this), type);
        }).on('input paste change', 'form[data-type] [name]', function () {
            $(this).closest('.form-contact__input').removeClass('error');
            $(this).closest('.form-contact__checkbox').removeClass('error');

            $(this).closest('.pop-up-form__input').removeClass('error').find('.form-contact__error').text('');
            $(this).closest('.pop-up-form__textarea').removeClass('error').find('.form-contact__error').text('');
            $(this).closest('.pop-up-form__checkbox').removeClass('error').find('.form-contact__error').text('');
        });
    },

    ajax: {
        obj: {}, url: AJAX_URL, send: function (success, failure) {
            $.post(this.url, this.obj, (answer) => {
                this.obj = {};
                answer.result && typeof success === 'function' ? success(answer) :
                    !answer.result && typeof failure === 'function' ? failure(answer) : null;
            }, 'JSON');
        },

        sendForm: function ($submitBtn, type) {
            this.obj.method = 'sendForm';
            this.obj.typeID = type;
            this.obj.data = Form.$form.serializeArray();
            this.send(function (answer) {
                Form.$form[0].reset();
                Form.$form.hide();

                $('.thank-form-id').show();

                setTimeout(function () {
                    Form.$form.show();
                    $('.thank-form-id').hide();
                }, 3000);

                if (type == 2) {

                } else {
                    Form.$form.find('.form-contact__input').find('span').attr('style', '');
                }
            }, (answer) => {
                $.each(answer.errors, (k, v) => {
                    console.log(type);

                    let blockClass = 'form-contact__input';

                    if (k === 'privacy_agrement') {
                        blockClass = 'form-contact__checkbox';
                    }

                    if (type == 2) {
                        blockClass = 'pop-up-form__input';

                        if (k === 'privacy_agrement') {
                            blockClass = 'pop-up-form__checkbox';
                        } else if (k === 'message') {
                            blockClass = 'pop-up-form__textarea';
                        }
                    }

                    Form.$form.find(`[name="${k}"]`).closest('.' + blockClass).addClass('error').find('.form-contact__error').html(v);
                });

                console.table(answer.errors);
            });
        },
    }
};